import {
  FormSubmitArgs,
  FormViewConfig,
  FormViewService,
  vsServiceName as FormViewServiceName,
  FormViewServiceProvider,
  vsProviderName as FormViewServiceProviderName,
} from "../../records/forms/formView";
import { RecordDataSource } from "../../records/grids";
import {
  ColumnDefinitionService,
  vsName as ColumnDefinitionServiceName,
} from "../../records/grids/columns/columnDefinitionService";
import {
  ServerUtility,
  vsName as ServerUtilityName,
} from "../../records/server/serverUtility";
import {
  GridConfiguration,
  RecordGridViewServiceProvider,
  vsProviderName as RecordGridViewServiceProviderName,
} from "../../records/views/recordGridView";
import fieldHelpers from "../../ui-formly/fieldHelpers";
import {
  LookupManagementConfig,
  LookupManagementServiceProvider,
} from "../../records/lookup/lookupManagement";
import { vsLookupManagementServiceProviderName } from "./lookupManagement";

export const vsObjectName = "typeOfAgreement";

const url = "api/contract/typesOfAgreement";

TypeOfAgreementConfig.$inject = [
  FormViewServiceProviderName,
  RecordGridViewServiceProviderName,
  vsLookupManagementServiceProviderName,
];

export function TypeOfAgreementConfig(
  formViewServiceProvider: FormViewServiceProvider,
  recordGridViewServiceProvider: RecordGridViewServiceProvider,
  lookupManagementServiceProvider: LookupManagementServiceProvider
) {
  recordGridViewServiceProvider.addGridConfiguration(
    vsObjectName,
    getGridConfig
  );
  lookupManagementServiceProvider.addLookup(vsObjectName, {
    displayName: "Type Of Agreement",
    config: [
      ServerUtilityName,
      (serverUtility: ServerUtility) => {
        const config: LookupManagementConfig = {
          fetchFormModel(id) {
            return serverUtility.querySingle({
              url,
              query: { Id: id },
            });
          },
          baseUrl: url,
        };
        return config;
      },
    ],
  });
  formViewServiceProvider.addFormViewConfig(vsObjectName, getFormConfig);
}

getGridConfig.$inject = [ServerUtilityName, ColumnDefinitionServiceName];
function getGridConfig(
  serverUtility: ServerUtility,
  columnDefinitionService: ColumnDefinitionService
): GridConfiguration {
  return {
    columns: [
      columnDefinitionService.getNumberColDef({ field: "Id", hide: true }),
      columnDefinitionService.getStringColDef({
        field: "Name",
        header: "Type Of Agreement",
      }),
      columnDefinitionService.getBooleanColDef({
        field: "Disabled",
      }),
    ],
    gridDataSource: new RecordDataSource(serverUtility, url),
    defaultSort: "Name",
    namePlural: "Types Of Agreement",
    nameSingular: "Type Of Agreement",
    showAddButton: true,
    showAddButtonPermission: "contractLookupModify",
    showSelectButtons: false,
  };
}

getFormConfig.$inject = [FormViewServiceName];
function getFormConfig(formViewService: FormViewService): FormViewConfig {
  return {
    fields: [
      fieldHelpers.simpleStringField({
        key: "Name",
        label: "Type Of Agreement",
        required: true,
      }),
      fieldHelpers.simpleBoolField({
        key: "Disabled",
        defaultValue: false,
      }),
    ],
    title: (model) =>
      model.Id ? "Edit Type Of Agreement" : "Create Type Of Agreement",
    name: vsObjectName,
    submitForm: (args: FormSubmitArgs) => {
      const model = args.model;
      return formViewService.saveForm({
        formObject: model,
        formViewController: args.formViewController,
        url,
      });
    },
  };
}
